import { render } from "./ProfileFavorites.vue?vue&type=template&id=45a46512&scoped=true"
import script from "./ProfileFavorites.vue?vue&type=script&lang=js"
export * from "./ProfileFavorites.vue?vue&type=script&lang=js"

import "./ProfileFavorites.vue?vue&type=style&index=0&id=45a46512&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a46512"]])

export default __exports__